import React from "react";
import { ThemeProvider } from "./services/ThemeProvider";
import LogoLoad from "./common/LogoLoad";

const Layout = React.lazy(() => import("./components/Layout"));

const App = () => {
  return (
    <ThemeProvider>
      <React.Suspense fallback={<LogoLoad />}>
        <Layout />
      </React.Suspense>
    </ThemeProvider>
  );
};

export default App;
